<template>

  <div>
    <SingleLineTextRenderer
        :data-test-path="'text-' + dynamicAttribute.name"
        v-if="dynamicAttribute && dynamicAttribute.type === 'Text'"
        ref="singleLineTextRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </SingleLineTextRenderer>
    <MultiLineTextRenderer
        :data-test-path="'long-text-' + dynamicAttribute.name"
        v-if="dynamicAttribute && dynamicAttribute.type === 'Long text'"
        ref="multilineLineTextRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </MultiLineTextRenderer>
    <CheckboxRenderer
        :data-test-path="'checkbox-' + dynamicAttribute.name"
        v-else-if="dynamicAttribute && dynamicAttribute.type === 'Checkbox'"
        ref="checkboxRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </CheckboxRenderer>
    <DateSelectRenderer
        :data-test-path="'date-' + dynamicAttribute.name"
        v-else-if="dynamicAttribute && dynamicAttribute.type === 'Date'"
        ref="dateRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </DateSelectRenderer>
    <IntegerRenderer
        :data-test-path="'integer-' + dynamicAttribute.name"
        v-else-if="dynamicAttribute && dynamicAttribute.type === 'Integer'"
        ref="integerRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"

    >
    </IntegerRenderer>
    <DecimalRenderer
        :data-test-path="'decimal-' + dynamicAttribute.name"
        v-else-if="dynamicAttribute && dynamicAttribute.type === 'Decimal'"
        ref="decimalRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </DecimalRenderer>
    <ColorPickerRenderer
        :data-test-path="'color-picker-' + dynamicAttribute.name"
        v-else-if="dynamicAttribute && dynamicAttribute.type === 'Color picker'"
        ref="colorPickerRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </ColorPickerRenderer>
    <DecimalCurrencyRenderer
        :data-test-path="'decimal-with-unit-' + dynamicAttribute.name"
        v-else-if="dynamicAttribute && (dynamicAttribute.type === 'Currency' || dynamicAttribute.type === 'Decimal with unit')"
        ref="decimalCurrencyRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </DecimalCurrencyRenderer>
    <StaticSelectRenderer
        :data-test-path="'dictionary-' + dynamicAttribute.name"
        v-else-if="localFieldConfig.optionsType && dynamicAttribute && dynamicAttribute.type === 'Dictionary'"
        ref="selectRenderer"
        :validated-field="validatedField"
        :field-config="localFieldConfig"
        :content="context"
        :mode="mode"
        :parent-form="parentForm"
    >
    </StaticSelectRenderer>

  </div>
</template>


<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import FormModel from "@/components/forms/FormModel";
import DynamicValueFormFieldConfig
  from "@/server/com/silkplm/engine/forms/schema/definition/DynamicValueFormFieldConfig";
import SingleLineTextRenderer from "@/components/forms/renderers/SingleLineTextRenderer";
import CheckboxRenderer from "@/components/forms/renderers/CheckboxRenderer";
import DateSelectRenderer from "@/components/forms/renderers/DateSelectRenderer";
import IntegerRenderer from "@/components/forms/renderers/IntegerRenderer";
import DecimalRenderer from "@/components/forms/renderers/DecimalRenderer";
import ColorPickerRenderer from "@/components/forms/renderers/ColorPickerRenderer";
import DecimalCurrencyRenderer from "@/components/forms/renderers/DecimalCurrencyRenderer";
import DecimalWithCurrency from "@/server/com/silkplm/rpc/dto/DecimalWithCurrency";
import Currency from "@/server/com/silkplm/model/plm/dictionaries/Currency";
import StaticSelectRenderer from "@/components/forms/renderers/StaticSelectRenderer";
import FormsLoader from "@/components/forms/FormsLoader";
import {cloneClassInstance} from "@/utils/Objects";
import DateFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DateFormFieldConfig";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";
import SelectFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import CheckboxFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/CheckboxFormFieldConfig";
import ColorPickerFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/ColorPickerFormFieldConfig";
import IntFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/IntFormFieldConfig";
import MultiLineTextRenderer from "@/components/forms/renderers/MultiLineTextRenderer";
import ValueAttribute from "@/server/com/silkplm/model/plm/ValueAttribute";
import CacheManager from "@/components/cacheManager/CacheManager";

const OPTIONS_FK_PRELOAD = "fk_preload";
export default {
  name: "DynamicValueRenderer",
  components: {
    MultiLineTextRenderer,
    StaticSelectRenderer,
    DecimalCurrencyRenderer,
    ColorPickerRenderer,
    DecimalRenderer,
    IntegerRenderer, DateSelectRenderer, CheckboxRenderer, SingleLineTextRenderer, ReachInput
  },
  async created() {
    this.validatedField.onChange(val => this.valChange(val));
    let formConfig = this.validatedField.getFormConfig();

    let valueAttributeField = this.parentForm.validatedFieldByName(this.fieldConfig.attributeField);
    let categoryAttribute = await valueAttributeField.getForeignInstance();
    this.dynamicAttribute = await categoryAttribute.getDynamicAttributesEntity();
    let fieldConfig;
    let valueAttribute = this.parentForm.originalSource;
    switch (valueAttribute.type) {
      case 'Text':
        fieldConfig = cloneClassInstance(this.fieldConfig, TextFormFieldConfig);
        break;
      case 'Long text':
        fieldConfig = cloneClassInstance(this.fieldConfig, TextFormFieldConfig);
        break;
      case 'Checkbox':
        fieldConfig = cloneClassInstance(this.fieldConfig, CheckboxFormFieldConfig);
        break;
      case 'Color picker':
        fieldConfig = cloneClassInstance(this.fieldConfig, ColorPickerFormFieldConfig);
        break;
      case 'Integer':
        fieldConfig = cloneClassInstance(this.fieldConfig, IntFormFieldConfig);
        break;
      case 'Date':
        fieldConfig = cloneClassInstance(this.fieldConfig, DateFormFieldConfig);
        fieldConfig.format = "L";
        fieldConfig.dateType = "LocalDate";
        break;

      case 'Decimal':
        fieldConfig = cloneClassInstance(this.fieldConfig, DecimalFormFieldConfig);
        fieldConfig.dataType = "Decimal";
        fieldConfig.step = new BigDecimal(0.01);
        fieldConfig.roundTo = 2;
        if (this.validatedField.value) {
          this.validatedField.value = new BigDecimal(this.validatedField.value);
        }
        break;

      case 'Currency':
      case 'Decimal with unit':
        fieldConfig = cloneClassInstance(this.fieldConfig, DecimalFormFieldConfig);
        fieldConfig.dataType = "DecimalWithCurrency";
        fieldConfig.step = new BigDecimal(0.01);
        break;

      case 'Dictionary':
        fieldConfig = cloneClassInstance(this.fieldConfig, SelectFormFieldConfig);
        let dynamicDictionaries = await CacheManager.getDynamicDictionaries();
        if (!dynamicDictionaries.hasOwnProperty(valueAttribute.dictionaryId)) {
          return;
        }
        let dict = dynamicDictionaries[valueAttribute.dictionaryId];
        let clazz = FormsLoader.detectFormConfig(dict.formId).formClassLong;
        fieldConfig.isForeignKey = true;
        fieldConfig.foreignClass = clazz;
        fieldConfig.formFieldConfig = formConfig;
        fieldConfig.fieldName = 'value';
        this.validatedField.getForeignOptions = () => {
          return CacheManager.getDynamicEntities(clazz);
        }
        this.validatedField.getForeignLabel = async () => {
          return CacheManager.getDynamicEntity(clazz, this.validatedField.value);
        }
        fieldConfig.optionsType = OPTIONS_FK_PRELOAD;
        break;
    }

    fieldConfig.fieldLabel = this.dynamicAttribute.name;

    this.validatedField.formFieldConfig = fieldConfig;
    this.localFieldConfig = fieldConfig;

    setTimeout(() => {
      this.setReadOnly(this.readOnly);
      if (this.editorMode) {
        this.setEditorMode();
      }
    });
    this.valChange(this.validatedField?.value);
  },

  async mounted() {
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: DynamicValueFormFieldConfig, required: true},
    context: {default: null},
    mode: {default: null},
    parentForm: {type: FormModel}
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
      for (let item in this.$refs) {
        this.$refs[item]?.setReadOnly?.(this.readOnly);
      }
    },

    setEditorMode(val) {
      this.editorMode = val;

      for (let item in this.$refs) {
        this.$refs[item]?.setEditorMode?.(val);
      }
    },

    /**
     * @param {Array} val
     */
    valChange(val) {
      if (!this.dynamicAttribute) {
        return;
      }
      try {
        this.processingChange = true;

      } finally {
        this.processingChange = false;
      }
    },
  },
  watch: {
    'validatedField': function (val) {
      if (this.processingChange) {
        return;
      }
      this.valChange(val.value);
    },
    'validatedField.value': function (val) {
      if (this.processingChange) {
        return;
      }
      this.valChange(val);
    },
  },
  data: function () {
    return {
      localFieldConfig: this.fieldConfig,
      allLabelsLoaded: false,
      readOnly: true,
      editorMode: false,
      /**
       * @Type{CategoryAttributes}
       */
      dynamicAttribute: {},
      processingChange: false,
      labelsLoaded: 0,
      type: null
    }
  }
}
</script>

<style scoped>

</style>